const GA_SCRIPT_SRC = 'https://www.googletagmanager.com/gtag/js?id=G-2EPFPD8H06';
const COOKIE_CONSENT_STORAGE_KEY = 'cookieConsent';

export const COOKIE_CONSENT_TYPES = Object.freeze({
  ALL: 'all',
  NECESSARY: 'necessary',
  ANALYTICS: 'analytics',
});

const appendScriptOnce = (src) => {
  const existingScript = document.querySelector(`script[src="${src}"]`);
  if (existingScript) {
    return existingScript;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
  return script;
};

const canLoadHotjar = () => window.location.protocol === 'https:';

const loadHotjar = () => {
  if (!canLoadHotjar()) {
    return;
  }

  if (window.hj) {
    window.hj('trigger', 'consent_given');
    return;
  }

  window.hj =
    window.hj ||
    function hotjarQueue() {
      // eslint-disable-next-line prefer-rest-params
      (window.hj.q = window.hj.q || []).push(arguments);
    };

  // eslint-disable-next-line no-underscore-dangle
  window._hjSettings = { hjid: 3293583, hjsv: 6 };
  // eslint-disable-next-line no-underscore-dangle
  const hotjarSrc = `https://static.hotjar.com/c/hotjar-${window._hjSettings.hjid}.js?sv=${window._hjSettings.hjsv}`;
  const script = appendScriptOnce(hotjarSrc);

  script.onload = () => {
    window.hj('trigger', 'consent_given');
  };
};

const injectCookies = () => {
  const gaScript = appendScriptOnce(GA_SCRIPT_SRC);

  gaScript.onload = () => {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    }

    gtag('js', new Date());
    gtag('config', 'G-2EPFPD8H06');
  };

  if (gaScript.complete) {
    gaScript.onload();
  }

  loadHotjar();
};

export const rejectCookieConsent = () => {
  localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, 'rejected');
};

export const acceptCookieConsent = (cookieType = COOKIE_CONSENT_TYPES.ALL) => {
  localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, 'accepted');

  if (cookieType !== COOKIE_CONSENT_TYPES.NECESSARY) {
    injectCookies();
  }
};

export const applyStoredCookieConsent = () => {
  if (localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) === 'accepted') {
    injectCookies();
  }
};

export { injectCookies };
